import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../api/axiosInstance";

// ----------- Async Thunk (UPDATE OTO settings) -----------
export const updateOtoSettings = createAsyncThunk(
  "otoSettings/update",
  async (data, thunkAPI) => {
    try {
      const response = await api.post("/dashboard/general-settings/oto-settings", data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ----------- Slice -----------
const otoSettingsSlicer = createSlice({
  name: "otoSettings",
  initialState: {
    data: null,
    loading: false,
    error: null,
    successMessage: "",
  },
  reducers: {
    clearOtoSettingsState: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateOtoSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateOtoSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(updateOtoSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearOtoSettingsState } = otoSettingsSlicer.actions;
export default otoSettingsSlicer.reducer;
